"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alphaLpBreakdown = alphaLpBreakdown;
exports.parentPoolLpBreakdown = parentPoolLpBreakdown;
exports.fetchRebalanceHistory = fetchRebalanceHistory;
exports.getlastAutocompoundTime = getlastAutocompoundTime;
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const simpleCache_js_1 = require("./protocol/simpleCache.js");
const index_js_1 = require("./pyth/index.js");
const decimal_js_1 = require("decimal.js");
async function alphaLpBreakdown(poolName, ignoreCache) {
    const pool = await (0, alphafi_sdk_1.getPool)(poolName, ignoreCache);
    if (pool) {
        const liquidity = pool.content.fields.tokensInvested;
        const amounts = await (0, alphafi_sdk_1.getCoinAmountsFromLiquidity)(poolName, liquidity, ignoreCache);
        const pool1 = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
        const pool2 = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
        const [priceOfCoin0, priceOfCoin1] = await (0, index_js_1.getLatestPrices)([`${pool1}/USD`, `${pool2}/USD`], ignoreCache);
        const coinA = new decimal_js_1.Decimal(amounts[0]).div(10 ** alphafi_sdk_1.coinsList[pool1].expo);
        const coinAInUsd = new decimal_js_1.Decimal(amounts[0])
            .mul(priceOfCoin0)
            .div(10 ** alphafi_sdk_1.coinsList[pool1].expo);
        const coinB = new decimal_js_1.Decimal(amounts[1]).div(10 ** alphafi_sdk_1.coinsList[pool2].expo);
        const coinBInUsd = new decimal_js_1.Decimal(amounts[1])
            .mul(priceOfCoin1)
            .div(10 ** alphafi_sdk_1.coinsList[pool2].expo);
        const res = {
            coinA: coinA.toString(),
            coinAInUsd: coinAInUsd.toString(),
            coinB: coinB.toString(),
            coinBInUsd: coinBInUsd.toString(),
            liquidity: new decimal_js_1.Decimal(liquidity).div(10 ** 10).toString(),
        };
        return res;
    }
}
async function parentPoolLpBreakdown(poolName, ignoreCache) {
    const pool = await (0, alphafi_sdk_1.getParentPool)(poolName, ignoreCache);
    if (pool) {
        const liquidity = pool.content.fields.liquidity;
        const amounts = [pool.content.fields.coin_a, pool.content.fields.coin_b];
        const pool1 = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
        const pool2 = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
        const [priceOfCoin0, priceOfCoin1] = await (0, index_js_1.getLatestPrices)([`${pool1}/USD`, `${pool2}/USD`], ignoreCache);
        const coinA = new decimal_js_1.Decimal(amounts[0]).div(10 ** alphafi_sdk_1.coinsList[pool1].expo);
        const coinAInUsd = new decimal_js_1.Decimal(amounts[0])
            .mul(priceOfCoin0)
            .div(10 ** alphafi_sdk_1.coinsList[pool1].expo);
        const coinB = new decimal_js_1.Decimal(amounts[1]).div(10 ** alphafi_sdk_1.coinsList[pool2].expo);
        const coinBInUsd = new decimal_js_1.Decimal(amounts[1])
            .mul(priceOfCoin1)
            .div(10 ** alphafi_sdk_1.coinsList[pool2].expo);
        const res = {
            coinA: coinA.toString(),
            coinAInUsd: coinAInUsd.toString(),
            coinB: coinB.toString(),
            coinBInUsd: coinBInUsd.toString(),
            liquidity: new decimal_js_1.Decimal(liquidity).div(10 ** 10).toString(),
        };
        return res;
    }
    return undefined;
}
const rebalanceCache = new simpleCache_js_1.SimpleCache();
async function fetchRebalanceHistory(poolName, ignoreCache = false) {
    const rebalanceCacheKey = `getRebalanceHistory-${poolName}`;
    if (ignoreCache) {
        rebalanceCache.delete(rebalanceCacheKey);
    }
    const cachedResponse = rebalanceCache.get(rebalanceCacheKey);
    if (cachedResponse) {
        return cachedResponse;
    }
    const res = await (0, alphafi_sdk_1.getRebalanceHistory)(poolName);
    rebalanceCache.set(rebalanceCacheKey, res);
    return res;
}
const lastAutoCompoundTimeCache = new simpleCache_js_1.SimpleCache();
async function getlastAutocompoundTime(poolName, ignoreCache = false) {
    const lastAutoCompoundTimeCacheKey = `lastAutoCompoundTime-${poolName}`;
    if (ignoreCache) {
        lastAutoCompoundTimeCache.delete(lastAutoCompoundTimeCacheKey);
    }
    const cachedResponse = lastAutoCompoundTimeCache.get(lastAutoCompoundTimeCacheKey);
    if (cachedResponse) {
        return cachedResponse;
    }
    const res = await (0, alphafi_sdk_1.getLastAutoCompoundTime)(poolName);
    lastAutoCompoundTimeCache.set(lastAutoCompoundTimeCacheKey, res);
    return res;
}
//# sourceMappingURL=vaultFunctions.js.map